import { render, staticRenderFns } from "./Tramos.vue?vue&type=template&id=481dc40f&"
import script from "./Tramos.vue?vue&type=script&lang=js&"
export * from "./Tramos.vue?vue&type=script&lang=js&"
import style0 from "./Tramos.vue?vue&type=style&index=0&id=481dc40f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports